import React, { Component } from "react";
import Helmet from "react-helmet";
import Navigation from "../components/Navigation/Navigation";
import SiteData from "../../data/SiteData";
import "./index.scss";

export default class MainLayout extends Component {
  getLocalTitle() {
    const currentPath = this.props.location.pathname.replace("/", "");
    let title = "";
    if (currentPath === "") {
      title = "Our Products";
    } else if (currentPath === "community") {
      title = "Community Work";
    } else if (currentPath === "contact") {
      title = "Contact Us";
    }
    return title;
  }
  render() {
    const { children } = this.props;
    const title = `${SiteData.title} | ${this.getLocalTitle()}`;
    return (
      <Navigation localTitle={title}>
        <Helmet>
          <title>
            {title}
          </title>
          <link rel="shortcut icon" href={SiteData.favicon} />
        </Helmet>
        {children()}
      </Navigation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.jsx